module.exports = __webpack_public_path__ + "img/star_3.a1d86712.jpg";